module.exports = __webpack_public_path__ + "img/Ekko-Header-2-Left@2x.d9b3b3a4.png";